(()=>{'use strict';
const drawer=document.getElementById('bb-cart-drawer');
if(!drawer)return;
const content=drawer.querySelector('[data-drawer-content]'),status=drawer.querySelector('[data-drawer-status]');
const root=window.Shopify?.routes?.root||'/';
let opener=null,busy=false,requestVersion=0,closing=false,cartChanged=false;
const announce=text=>status.textContent=text;
const open=()=>{
  if(drawer.open)return;
  opener=document.activeElement;
  drawer.showModal();
  document.body.classList.add('bb-drawer-open');
  requestAnimationFrame(()=>requestAnimationFrame(()=>drawer.classList.add('is-open')));
  drawer.querySelector('[data-drawer-close]').focus();
  window.dispatchEvent(new Event('resize'));
};
const close=()=>{
  if(!drawer.open||closing)return;
  closing=true;drawer.classList.remove('is-open');
  const finish=()=>{
    if(!closing)return;
    closing=false;drawer.close();document.body.classList.remove('bb-drawer-open');
    if(opener?.isConnected)opener.focus();
    if(cartChanged&&location.pathname.replace(/\/$/,'').endsWith('/cart'))location.assign(root+'cart');
    window.dispatchEvent(new Event('resize'));
  };
  if(matchMedia('(prefers-reduced-motion:reduce)').matches)finish();
  else{drawer.addEventListener('transitionend',finish,{once:true});setTimeout(finish,280);}
};
const setBusy=value=>{
  busy=value;content.setAttribute('aria-busy',String(value));
  if(value)content.querySelectorAll('button,input,select').forEach(control=>{
    control.dataset.drawerWasDisabled=String(control.disabled);control.disabled=true;
  });
  else content.querySelectorAll('[data-drawer-was-disabled]').forEach(control=>{
    control.disabled=control.dataset.drawerWasDisabled==='true';delete control.dataset.drawerWasDisabled;
  });
};
const render=html=>{
  if(!html)throw Error(drawer.dataset.errorLabel);
  const parsed=new DOMParser().parseFromString(html,'text/html').querySelector('[data-drawer-content]');
  if(!parsed)throw Error(drawer.dataset.errorLabel);
  const scroll=content.querySelector('[data-drawer-scroll]')?.scrollTop||0;
  const rail=content.querySelector('.bb-cart-addon-rail')?.scrollLeft||0;
  const focusKey=document.activeElement?.dataset.focusKey;
  content.replaceChildren(...Array.from(parsed.childNodes).map(node=>document.importNode(node,true)));
  content.dataset.itemCount=parsed.dataset.itemCount;
  content.querySelectorAll('[data-drawer-update]').forEach(button=>button.hidden=true);
  content.querySelector('[data-drawer-scroll]')?.scrollTo({top:scroll});
  content.querySelector('.bb-cart-addon-rail')?.scrollTo({left:rail});
  if(focusKey){const next=Array.from(content.querySelectorAll('[data-focus-key]')).find(el=>el.dataset.focusKey===focusKey);next?.focus({preventScroll:true});}
  document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=parsed.dataset.itemCount);
};
const refresh=async()=>{
  const version=++requestVersion;
  announce(drawer.dataset.loadingLabel);setBusy(true);
  try{
    const response=await fetch(root+'?sections=bb-cart-drawer',{headers:{Accept:'application/json'},cache:'no-store'});
    if(!response.ok)throw Error(drawer.dataset.errorLabel);
    const sections=await response.json();
    if(version!==requestVersion)return;
    render(sections['bb-cart-drawer']);announce('');
  }catch(error){if(version===requestVersion)announce(drawer.dataset.errorLabel);}
  finally{if(version===requestVersion)setBusy(false);}
};
const change=async(key,quantity)=>{
  if(busy)return;
  announce(drawer.dataset.loadingLabel);setBusy(true);
  try{
    const response=await fetch(root+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity,sections:'bb-cart-drawer',sections_url:root})});
    const cart=await response.json();
    if(!response.ok)throw Error(cart.description||cart.message||drawer.dataset.quantityError);
    render(cart.sections?.['bb-cart-drawer']);announce('');cartChanged=true;
    document.dispatchEvent(new CustomEvent('bb:drawer-cart-updated',{detail:{cart}}));
  }catch(error){await refresh();announce(error.message||drawer.dataset.errorLabel);}
  finally{setBusy(false);}
};
document.addEventListener('click',event=>{
  const trigger=event.target.closest('a.header-cart,[data-open-cart]');
  if(trigger&&!event.metaKey&&!event.ctrlKey&&!event.shiftKey&&!event.altKey&&event.button===0){event.preventDefault();open();if(!busy)refresh();return;}
  if(!drawer.contains(event.target))return;
  if(event.target.closest('[data-drawer-close]')){close();return;}
  const remove=event.target.closest('[data-drawer-remove]');
  if(remove){event.preventDefault();change(remove.dataset.lineKey,0);return;}
  const step=event.target.closest('[data-drawer-step]');
  if(step&&!busy){const input=step.closest('.bb-drawer-quantity').querySelector('input');if(step.dataset.drawerStep==='plus')input.stepUp();else input.stepDown();if(input.reportValidity())change(input.dataset.lineKey,input.valueAsNumber);}
});
drawer.addEventListener('click',event=>{if(event.target===drawer){const bounds=drawer.getBoundingClientRect();if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom)close();}});
drawer.addEventListener('cancel',event=>{event.preventDefault();close();});
drawer.addEventListener('change',event=>{const input=event.target.closest('[data-drawer-quantity]');if(input&&!busy&&input.reportValidity())change(input.dataset.lineKey,input.valueAsNumber);});
drawer.addEventListener('submit',event=>{if(event.target.id==='DrawerCartLines'&&event.submitter?.name!=='checkout')event.preventDefault();});
document.addEventListener('bb:cart-updated',()=>{cartChanged=true;open();refresh();});
if(new URLSearchParams(location.search).get('cart_drawer')==='1'){open();refresh();}
})();
